import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/homeData';

const SEOArticlesSection = () => (
  <section id="artigos" className="relative bg-background-50 py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-600 mb-3">Artigos & Guias</p>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Guias do Hoobuy<br />Spreadsheet
          </h2>
        </div>
        <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
          Artigos originais e otimizados para ajudar você a aproveitar ao máximo o <strong>Hoobuy Spreadsheet</strong>. Conteúdo exclusivo em português.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {seoArticles.map((article) => (
          <Link
            key={article.id}
            to={`/artigo/${article.slug}`}
            className="group bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden flex flex-col transition-all duration-300 hover:border-background-300 cursor-pointer"
          >
            <div className="relative w-full aspect-[3/2] overflow-hidden">
              <img
                src={article.imageUrl}
                alt={article.title}
                title={article.title + " - Hoobuy Spreadsheet"}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
            <div className="p-5 flex flex-col flex-1">
              <div className="flex items-center gap-2 mb-3">
                <span className="flex items-center gap-1 text-[10px] text-foreground-500">
                  <i className="ri-time-line"></i>
                  {article.readTime}
                </span>
                <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                <span className="text-[10px] text-foreground-500">Hoobuy.homes</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                {article.excerpt}
              </p>
              <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                Ler artigo
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-10 text-center">
        <Link
          to="/artigo/guia-completo-hoobuy-spreadsheet-2026"
          className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
        >
          Ver todos os artigos e guias
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </div>
  </section>
);

export default SEOArticlesSection;